import { QueryHookOptions } from '@apollo/client';
import { CountryOption } from '@anytag/shared-types';
import { Query, useAllAvailableCountriesQuery } from '@anytag/graphql';
import { useTranslateCountryOptions } from './useTranslateOptions';

export const useAllAvailableCountryOptions = (props: QueryHookOptions<Query> = {}) => {
  const { data, loading } = useAllAvailableCountriesQuery({ fetchPolicy: 'no-cache', ...props });

  const availableCountryOptions =
    data?.allAvailableCountries.map<CountryOption>(({ id, name, currency }) => ({
      currency,
      value: id,
      label: name
    })) || [];

  return {
    loading,
    allAvailableCountryOptions: useTranslateCountryOptions(availableCountryOptions)
  };
};
